module.exports = __webpack_public_path__ + "static/media/Landscape_gif_tv.6e031120.gif";